module.exports = __webpack_public_path__ + "img/emoticon-nps-4-off.95fc254c.svg";